import React from "react";
import Context from "../../../../../Context";
import UsersListRow from "./UsersListRow";
import List from "../../../../Misc/List";
import FieldsList from "../../../../Misc/FieldsList";
import Sortings from "../../../../Misc/Sortings";
import Filters from "../../../../Misc/Filters";
import { Link } from "react-router-dom";

let searchTimeout = null;

export default class UsersList extends React.Component {
  static contextType = Context;
  static fieldsStorageName = "userListFields";
  constructor(props) {
    super(props);
    let savedFields = localStorage.getItem(this.fieldsStorageName)
      ? JSON.parse(localStorage.getItem(this.fieldsStorageName))
      : [];
    this.state = {
      pending: false,
      searchPending: false,
      search: [],
      filters: {
        show: false,
        active: [],
        all: [
          {
            id: "created",
            title: "По дате создания",
            kind: "range",
            active: false,
            value: [],
          },
        ],
      },
      fields: {
        all: [
          "id",
          "username",
          "name",
          "description",
          "phone",
          "email",
          "status",
        ],
        active: savedFields,
      },
      sortings: {
        all: [
          {
            id: "byUsernameAsc",
            active: false,
            title: "По лоигину",
            value: ["username ASC"],
          },
          {
            id: "byCreatedDesc",
            active: false,
            title: "По дате создания",
            value: ["created DESC"],
          },
        ],
        active: [],
      },
    };
  }

  toggleFilters = (v) => {
    this.setState((state) => {
      let filters = state.filters;
      filters.show = v;
      return { filters };
    });
  };

  handleFilters = (changedFilters) => {
    this.setState((state) => {
      let filters = state.filters;
      filters.active = changedFilters;
      return { filters };
    });
  };
  handleFields = (changedFields) => {
    localStorage.setItem(this.fieldsStorageName, JSON.stringify(changedFields));
    this.setState((state) => {
      let fields = state.fields;
      fields.active = changedFields;
      return { fields };
    });
  };
  handleSortings = (chnagedSortings) => {
    this.setState((state) => {
      let sortings = state.sortings;
      sortings.active = chnagedSortings;
      return { sortings };
    });
  };
  handleSearch = (searchValue) => {
    this.setState({ searchPending: true });
    window.clearTimeout(searchTimeout);
    searchTimeout = window.setTimeout(() => {
      let search = searchValue
        ? [
            {
              lstr: "(",
              field: "username",
              compare: "IKE",
              value: `%${searchValue}%`,
              condition: "OR",
            },
            {
              field: "name",
              compare: "IKE",
              value: `%${searchValue}%`,
              rstr: ")",
              condition: "OR",
            },
          ]
        : [];
      this.setState({ searchPending: false, search });
    }, 1500);
  };

  render() {
    let filters = (
      <div
        className={`${
          this.state.filters.show ? "d-flex" : "d-none"
        }  align-items-center justify-content-end mt-0 py-5 px-7 mb-2 border-bottom w-100 shadow-sm`}
      >
        <Filters
          changeFn={this.handleFilters}
          filters={this.state.filters.all}
        />
      </div>
    );
    return (
      <>
        <div className="card card-custom gutter-b ">
          <div className="card-header">
            <div className="card-title w-100 mr-0 p-lg-0 py-5 d-block d-lg-flex align-items-center justify-content-between">
              <h3>Пользователи</h3>
              <div>
                <div className="text-nowrap d-inline-block mr-2">
                  {this.state.searchPending ? (
                    <div className="spinner mr-10 d-inline-block"></div>
                  ) : (
                    ""
                  )}
                  <input
                    className="form-control form-control-solid d-inline-block w-auto"
                    type="text"
                    placeholder="Поиск"
                    onChange={(e) => this.handleSearch(e.target.value)}
                  />
                </div>
                <Link
                  to="/admin/users/add/"
                  className="btn btn-light mr-2 text-hover-primary"
                >
                  <i className="flaticon2-add-1 p-0 align-middle text-muted"></i>
                </Link>

                {false ? (
                  <FieldsList
                    changeFn={this.handleFields}
                    fields={this.state.fields.all}
                    activeFields={this.state.fields.active}
                  />
                ) : null}

                <button
                  className="btn btn-light mr-2"
                  onClick={() => this.toggleFilters(!this.state.filters.show)}
                >
                  <i
                    className={`fa fa-filter p-0 ${
                      this.state.filters.show ? "text-primary" : "text-muted"
                    }`}
                  ></i>
                </button>
                <Sortings
                  changeFn={this.handleSortings}
                  sortings={this.state.sortings.all}
                />
              </div>
            </div>
          </div>
          {filters}
          <div className="card-body">
            <List
              listKey="UsersList"
              fulltext={JSON.stringify(this.state.search)}
              search={JSON.stringify(this.state.filters.active)}
              sort={JSON.stringify(this.state.sortings.active)}
              fields={JSON.stringify(this.state.fields.active)}
              limit={20}
              keyField="id"
              path="/admin/user/list"
            >
              <UsersListRow />
            </List>
          </div>
        </div>
      </>
    );
  }
}
